// import { userService } from '@/plugin/axios'
import { userService } from '../service'; // 查询数据

export function LoadData(query) {
  return userService.get('SysOrganize/LoadData', {
    params: query
  });
} // 查询组织架构树

export function LoadTreeData() {
  return userService.get('SysOrganize/LoadTreeData');
} // 当前ID是否已被使用

export function ItemIsByUsed(id) {
  return userService.get('SysOrganize/ItemIsByUsed', {
    params: {
      id: id
    }
  });
} // 保存数据

export function SaveData(data) {
  return userService.post('SysOrganize/SaveData', data);
} // 添加或修改视图

export function AddOrModify() {
  return userService.get('SysOrganize/AddOrModify');
} // 删除

export function DeleteOneById(id) {
  return userService.post('SysOrganize/DeleteOneById', {}, {
    params: {
      id: id
    }
  });
} // 组织类型LoadData

export function TypeLoadData(query) {
  return userService.get('SysOrganizeType/LoadData', {
    params: query
  });
} // 查询 组织架构人员关联数据

export function LoadUserOrganize(query) {
  return userService.get('SysOrganize/LoadUserOrganize', {
    params: query
  });
} // 保存 组织架构人员关联数据

export function SaveUserOrganize(data) {
  return userService.post('SysOrganize/SaveUserOrganize', data);
} // 用户列表

export function ManagerLoadData(query) {
  return userService.get('Manager/LoadData', {
    params: query
  });
}